import React from "react";

import { FooterData } from "@swo/storefront";
import { css } from "@emotion/react";

export const PaymentMethods: React.FC<{ data: FooterData["paymentMethods"] }> = props => {
  const paymentStyles = css`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 10px;
  `;

  return (
    <div css={paymentStyles}>
      {props.data.map(({ url, title }, idx) => (
        <img key={url || idx} src={url} alt={title} loading={"lazy"} width={50} height={30} />
      ))}
    </div>
  );
};
